import FormattedNumber from '../_components/formattedNumber';

export const hasTaxLimitation = (unit) =>
  Boolean(unit) && parseInt(unit.freezeYr, 10) > 0;

const TaxLimitationTab = ({ parseFloatKeep, unit }) => (
  <div className='tax-limitation-container'>
    <p>
      Your current taxes for this taxing unit are limited by an exemption you
      qualified in
      <span className='highlight'> {unit.freezeYr} </span>
      for property owners that are disabled or 65 years of age or older. Your
      taxes are limited to not increase above
      <span className='highlight'>
        {' '}
        $
        <FormattedNumber value={parseFloatKeep(unit.freezeCeiling)} />{' '}
      </span>
      unless certain new improvements are made to your residence that are
      excluded from this limitation.
    </p>
  </div>
);

export default TaxLimitationTab;
